import useAddCredit from './useAddCredit';
import useBaitRenewal from './useBaitRenewal';
import useBrokerCancellation from './useBrokerCancellation';
import useChangeApn from './useChangeApn';
import useExchangeStep from './useExchangeStep';
import useFinancialLockUnlock from './useFinancialLockUnlock';
import useForceReactivation from './useForceReactivation';
import useImeiLockUnlock from './useImeiLockUnlock';
import useManualActivation from './useManualActivation';
import useMotDeactivation from './useMotDeactivation';
import useMotOperatorChange from './useMotOperatorChange';
import useSuspensionWithdrawal from './useSuspensionWithdrawal';
import useTransfer from './useTransfer';

const MoT = {
  useBrokerCancellation,
  useSuspensionWithdrawal,
  useAddCredit,
  useExchangeStep,
  useFinancialLockUnlock,
  useForceReactivation,
  useImeiLockUnlock,
  useManualActivation,
  useMotDeactivation,
  useMotOperatorChange,
  useTransfer,
  useChangeApn,
  useBaitRenewal,
};

export default MoT;
